/**
 * Модели сделки. Клиенту показываются бытовым языком, без терминов.
 * Модель подставляется по умолчанию из ниши, клиент подтверждает или меняет.
 */

export const DEAL_MODEL = {
  ONE_TIME: 'one_time',
  REPEAT: 'repeat',
  SUBSCRIPTION: 'subscription',
  PROJECT: 'project',
};

export const DEAL_MODEL_LIST = [
  {
    id: DEAL_MODEL.ONE_TIME,
    label: 'Разовая покупка',
    description: 'Клиент покупает один раз и обычно не возвращается',
    examples: 'ремонт квартиры, свадебная съёмка, покупка курса',
    /** Сколько раз в год клиент покупает — база для рычага «частота». */
    defaultFrequency: 1,
    /** Насколько реалистично растить частоту в этой модели. */
    frequencyGrowthCap: 0.15,
  },
  {
    id: DEAL_MODEL.REPEAT,
    label: 'Клиент возвращается снова и снова',
    description: 'Покупки повторяются без фиксированного графика',
    examples: 'кафе, маникюр, магазин, автосервис',
    defaultFrequency: 4,
    frequencyGrowthCap: 0.4,
  },
  {
    id: DEAL_MODEL.SUBSCRIPTION,
    label: 'Регулярная оплата',
    description: 'Клиент платит по графику, пока не отменит',
    examples: 'абонемент, курс с рассрочкой, клуб',
    defaultFrequency: 12,
    frequencyGrowthCap: 0.3,
  },
  {
    id: DEAL_MODEL.PROJECT,
    label: 'Долгий проект, оплата по этапам',
    description: 'Одна сделка растянута во времени, оплата частями',
    examples: 'стройка, B2B-услуги, разработка',
    defaultFrequency: 1,
    frequencyGrowthCap: 0.2,
  },
];

export const DEAL_MODEL_MAP = DEAL_MODEL_LIST.reduce((acc, model) => {
  acc[model.id] = model;
  return acc;
}, {});

export const getDealModel = (dealModelId) =>
  DEAL_MODEL_MAP[dealModelId] || DEAL_MODEL_MAP[DEAL_MODEL.REPEAT];

/**
 * Запасной вопрос, если клиент не узнал себя ни в одной нише.
 * Ответ маршрутизирует в розницу или услугу.
 */
export const FALLBACK_NICHE_QUESTION = {
  question:
    'Сначала идёт консультация, приём или замер, а потом оплата — или клиент сразу платит за товар?',
  answers: [
    { id: 'service_first', label: 'Сначала консультация, приём или замер', nicheId: 'b2b' },
    { id: 'pay_first', label: 'Клиент сразу платит за товар', nicheId: 'retail_offline' },
  ],
};
